import type { FC, ReactNode } from 'react';
import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import KeycloakUserService from 'utils/KeycloakUserService';
import { Routes } from '../constants';
import useCurrentLanguage from 'hooks/useCurrentLanguage';

interface AuthGuardProps {
  children: ReactNode;
}

const AuthGuard: FC<AuthGuardProps> = (props) => {
  const { children } = props;
  const location = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);
  const [currentLanguage] = useCurrentLanguage();

  if (KeycloakUserService.userNeedsRegistrationCompletion()) {
    return <Navigate to={Routes.FinishRegistration} />;
  }

  if (!KeycloakUserService.isLoggedIn()) {
    if (location.pathname !== requestedLocation) {
      setRequestedLocation(location.pathname);
    }

    KeycloakUserService.doLogin({ locale: currentLanguage });
    return <></>;
  }

  // This is done so that in case the route changes by any chance through other
  // means between the moment of request and the render we navigate to the initially
  // requested route.
  if (requestedLocation && location.pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default AuthGuard;
